import { createFileRoute } from '@tanstack/react-router'
import McpServerSettings from '@/pages/settings/mcp-server'

export const Route = createFileRoute(
  '/(protected)/settings/mcp-server'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <McpServerSettings />
}
